import React, { Component, PropTypes } from 'react';
import styles from '../Header.scss';

export default class HeaderContacts extends Component {
  render() {
    return (
      <div className={styles.contacts}>
        8 (925) 179 35 79
      </div>
    );
  }
}



HeaderContacts.propTypes = {
};



/** WEBPACK FOOTER **
 ** ./src/components/Header/elements/HeaderContacts.jsx
 **/